import data from "../../../../../src/Label.docs.json";
import * as React from 'react';
export default {
  data,
  React
};